import cn from 'classnames';
import { Tooltip } from 'seagull';
import { Edit2Liner24Circle } from 'seagull/icons';
import styles from "./EditableTableCell.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function EditableTableCell(props) {
  const {
    children,
    testid,
    onClick,
    className,
    isDisabled,
    disabledTooltip
  } = props;
  const content = /*#__PURE__*/_jsxs("button", {
    className: styles.button,
    "data-testid": testid,
    disabled: isDisabled,
    onClick: onClick,
    children: [/*#__PURE__*/_jsx("div", {
      children: children
    }), /*#__PURE__*/_jsx("div", {
      className: styles.icon,
      children: /*#__PURE__*/_jsx(Edit2Liner24Circle, {})
    })]
  });
  return /*#__PURE__*/_jsx("div", {
    className: cn(styles.root, className),
    children: disabledTooltip ? /*#__PURE__*/_jsx(Tooltip, {
      title: disabledTooltip || '',
      "data-testid": "".concat(testid, "-disabled-tooltip"),
      placement: "right",
      children: content
    }) : content
  });
}